// InvoiceTopToolBarActions.jsx
import { useCallback, useState } from 'react';
import { Box, Button } from '@material-ui/core';
import { useTranslate, useNotify, useMutation, useRefresh } from 'react-admin';
import ExportDialog from './ExportDialog';

const InvoiceTopToolBarActions = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);

  const [exportReport, { loading }] = useMutation(
    {
      type: 'others',
      resource: 'invoices',
    },
    {
      onSuccess: ({ data }) => {
        if (!data?.csv_file) {
          notify('No invoices found for this period', 'info');
        } else {
          window.open(data.csv_file, '_blank');
        }
        refresh();
      },
      onFailure: ({ message }) => {
        notify(message || translate('Export failed'), 'warning');
        refresh();
      },
    }
  );

  const handleExport = useCallback(
    ({ date_from, date_to }) => {
      exportReport({
        payload: {
          action: 'EXPORT_REPORT',
          data: {
            date_from: date_from?.toISOString().slice(0, 10) ?? null,
            date_to: date_to?.toISOString().slice(0, 10) ?? null,
          },
        },
      });
    },
    [exportReport]
  );

  return (
    <>
      <Box flex="1" p={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpen(true)}
          disabled={loading}
        >
          {translate('common_export')}
        </Button>
      </Box>
      <ExportDialog
        open={open}
        loading={loading}
        onClose={() => setOpen(false)}
        onConfirm={(range) => {
          handleExport(range);
          setOpen(false);
        }}
      />
    </>
  );
};

export default InvoiceTopToolBarActions;
